class TabImage {
  constructor(section) {
    this.section = section;
    this.tabs = section.querySelector('.tab-image__tabs');
    this.activeTab = section.querySelector('.tab-image__tab.active');
    this.currentIndex = this.activeTab ? parseInt(this.activeTab.getAttribute('data-index')) : 0;
    this.isAnimating = false;
    
    this.init();
  }

  init() {
    this.setupObserver();
    this.setupEventListeners();
  }

  setupObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.tabs.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    observer.observe(this.section);
  }

  setupEventListeners() {
    const tabButtons = this.section.querySelectorAll('.tab-image__tab');
    tabButtons.forEach((tab, index) => {
      tab.addEventListener('click', () => this.openTab(tab, index));
      tab.addEventListener('mouseenter', () => this.handleTabHover(tab, index));
      tab.addEventListener('mouseleave', () => this.handleTabLeave(tab));
    });
  }

  openTab(element, index) {
    if (this.isAnimating) return;
    this.isAnimating = true;

    const contentItems = this.section.querySelectorAll('.tab-image__content-item');
    const currentItem = this.section.querySelector('.tab-image__content-item.active');
    
    contentItems.forEach(item => {
      item.classList.remove('active');
      const container = item.querySelector('.tab-image__content-item-container');
      if (container) {
        container.style.opacity = '0';
      }
    });
    
    const newItem = this.section.querySelector(`#${element.getAttribute('data-tab-id')}`);
    newItem.classList.add('active');
    
    this.currentIndex = index;
    
    this.section.querySelectorAll('.tab-image__tab').forEach(tab => {
      tab.classList.remove('active', 'stretch-left', 'stretch-right');
    });
    element.classList.add('active');

    setTimeout(() => {
      const activeContainer = newItem.querySelector('.tab-image__content-item-container');
      if (activeContainer) {
        activeContainer.style.opacity = '1';
      }
    }, 50);

    setTimeout(() => {
      this.isAnimating = false;
    }, 500);
  }

  handleTabHover(hoveredTab, hoveredIndex) {
    const activeTab = this.section.querySelector('.tab-image__tab.active');
    if (!activeTab || hoveredTab === activeTab) return;

    activeTab.classList.remove('stretch-left', 'stretch-right');

    if (hoveredIndex > this.currentIndex) {
      activeTab.classList.add('stretch-right');
    } else if (hoveredIndex < this.currentIndex) {
      activeTab.classList.add('stretch-left');
    }
  }

  handleTabLeave(hoveredTab) {
    const activeTab = this.section.querySelector('.tab-image__tab.active');
    if (activeTab) {
      activeTab.classList.remove('stretch-left', 'stretch-right');
    }
  }
}

// 初始化所有tab-image组件
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('[id^="tab-image-"]');
  sections.forEach(section => new TabImage(section));
}); 